<template>
  <div class="editBG pt-3 mt-4">
    <v-snackbar
      v-model="snackbar"
      auto-height
      :color="sColor"
      right
      top
      :timeout="timeout"
      vertical
      >{{ sText }}</v-snackbar
    >

    <v-navigation-drawer
      width="420"
      temporary
      absolute
      fixed
      right
      dark
      style="position: fixed; top: 224px"
      class="px-2 navbar"
      hide-overlay
      v-model="options_c"
    >
      <v-layout row pt-3 pl-2 pb-2>
        <v-flex>
          <v-subheader
            class="font-weight-regular display-1 white--text pl-0 ml-2"
          >
            Options
            <v-spacer></v-spacer>
            <a
              @click="options_c = false"
              class="font-weight-regular display-1 white--text"
            >
              X</a
            >
            <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
          </v-subheader>
        </v-flex>
      </v-layout>

      <!-- <h1 class="pl-3 pt-3 pb-2 font-weight-regular display-1 white--text">Options</h1> -->
      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <v-layout row pt-0 mt-0>
        <v-flex>
          <v-subheader class="white--text">
            Editing Artist
            <v-spacer></v-spacer>
            <!-- <a @click="clear_selection" v-if="this.selected.length>0">Clear Selection</a> -->
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-list>
        <v-list-tile
          class="pl-0 ml-4"
          v-for="tab in this.constants.ARTIST.tabs"
          :key="tab.key"
          @click="setCurrentTab(tab['key'])"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ tab.title }} </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>
      <v-layout row pt-0 mt-0>
        <v-flex>
          <v-subheader class="white--text">
            Export PDF for:
            <v-spacer></v-spacer>
            <a @click="">Export</a>
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-layout
      row
      wrap
      style="
        background-color: white;
        height: 30px;
        width: 100%;
        top: 135px;
        position: fixed;
        z-index: 1;
        height: 50px;
      "
    >
      <v-flex xs12> </v-flex>
    </v-layout>

    <v-toolbar
      tabs
      color="white"
      class="elevation-1 mt-2"
      style="top: 155px; position: fixed; z-index: 1"
    >
      <v-toolbar-title class="pl-4">
        <v-icon
          v-if="artistFormData.collective == '1'"
          class="hidden-sm-and-down mr-3"
          color="black"
          >people</v-icon
        >
        <v-icon
          v-if="artistFormData.collective != '1'"
          class="hidden-sm-and-down mr-3"
          color="black"
          >person</v-icon
        >
        {{ artistFormData.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-flex px-3 xs12 right> -->
      <v-btn
        v-if="c_user.delete_rights"
        small
        icon
        class="mr-3"
        @click="$router.go(-1)"
        right
      >
        <v-icon small color="red">delete</v-icon>
      </v-btn>
      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn
        icon
        small
        :disabled="!valid"
        v-if="c_user.edit"
        @click="saveArtist"
        right
      >
        <v-icon small>save</v-icon>
      </v-btn>
      <!-- </v-flex> -->
      <!-- <a class="headline mr-2 pr-2 black--text" @click="options=false;$router.go(-1)">close</a> -->
    </v-toolbar>

    <v-form
      @submit.prevent
      ref="form"
      v-model="valid"
      lazy-validation
      v-if="currentTab == 'basic'"
    >
      <v-card class="px-3 mt-4 elevation-0 editBG pt-3">
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <section-header text="Basic"></section-header>

            <v-flex px-3 pt-3 xs12 md6>
              <v-text-field
                v-if="c_user.edit"
                hint="used for all views"
                @keyup="check_name($event.target.value)"
                :label="
                  artistFormData.collective == 1
                    ? 'Collective Name'
                    : 'Full Name'
                "
                v-model="artistFormData.name"
              ></v-text-field>

              <v-flex v-else mt-4>
                <code>{{ artistFormData.name }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">{{
                  artistFormData.collective == 1
                    ? 'Collective Name'
                    : 'Full Name'
                }}</label>
              </v-flex>
            </v-flex>

            <v-flex px-3 pt-3 md6 xs12>
              <v-text-field
                v-if="c_user.edit"
                label="Sort Name"
                hint="used for sorting in list views"
                v-model="artistFormData.sort_name"
              ></v-text-field>

              <v-flex v-else mt-4>
                <code>{{ artistFormData.sort_name }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Sort Name</label>
              </v-flex>
            </v-flex>

            <v-flex px-3 pb-3 xs12 md6 v-if="!artistFormData.collective == 1">
              <v-text-field
                v-if="c_user.edit"
                label="First Name"
                v-model="artistFormData.first_name"
                persistent-hint
              ></v-text-field>
              <!-- hint="legacy field not used anymore" -->

              <v-flex v-else>
                <code>{{ artistFormData.first_name }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">First Name</label>
              </v-flex>
            </v-flex>

            <v-flex px-3 pb-3 xs12 md6 v-if="!artistFormData.collective == 1">
              <v-text-field
                v-if="c_user.edit"
                label="Last Name"
                v-model="artistFormData.last_name"
                persistent-hint
              ></v-text-field>
              <!-- hint="legacy field not used anymore" -->

              <v-flex v-else>
                <code>{{ artistFormData.last_name }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Last Name</label>
              </v-flex>
            </v-flex>

            <v-flex px-3 pb-1 xs12 md6 v-if="!artistFormData.collective == 1">
              <v-text-field
                v-if="c_user.edit"
                label="Birth Name"
                v-model="artistFormData.birth_name"
                hide-details
              ></v-text-field>

              <v-flex v-else>
                <code>{{ artistFormData.birth_name }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Birth Name</label>
              </v-flex>
            </v-flex>

            <section-header text="Birth & Death / Formation"></section-header>

            <!-- <v-flex
              style="background-color: #292929; color: #ddd; line-height: 22px"
              class="px-2 py-0 mt-3 xs12"
            >
              <h3 class="font-weight-bold body-2 xs12 flex">
                <span v-if="!artistFormData.collective == 1"
                  >Birth & Death</span
                >
                <span v-else>Formation</span>
              </h3>
            </v-flex> -->

            <!-- <v-flex
              xs6
              class="mt-3 py-0 px-3"
              v-if="
                artistFormData.birth_date_only_year == 1 ||
                artistFormData.collective == 1
              "
            >
              <v-text-field
                clearable
                v-model="artistFormData.birth_date_year"
                mask="####"
                :label="
                  artistFormData.collective == 1
                    ? 'Formation Year'
                    : 'Birth Year'
                "
                prepend-icon="event"
              ></v-text-field>
            </v-flex> -->

            <!-- BIRTH DATE -->
            <v-flex xs12 sm6 d-flex pl-0>
              <v-flex xs12 sm4 pl-3 py-3>
                <v-text-field
                  v-if="c_user.edit"
                  v-model="artistFormData.birth_date_year"
                  label="Year"
                  placeholder="0000"
                  mask="####"
                  type="number"
                  :maxlength="4"
                ></v-text-field>

                <v-flex v-else mt-4>
                  <code>{{ artistFormData.birth_date_year }}</code>
                  <!-- <label v-if="label != ''">{{ label }}</label> -->
                  <label style="color: #999">Year</label>
                </v-flex>

                Decade: {{ getDecade(artistFormData.birth_date_year) }}
              </v-flex>

              <v-flex xs12 sm4 mt-0 py-3>
                <v-text-field
                  v-if="c_user.edit"
                  v-model="artistFormData.birth_date_month"
                  label="Month"
                  mask="##"
                  placeholder="00"
                  type="number"
                ></v-text-field>

                <v-flex v-else mt-4>
                  <code>{{ artistFormData.birth_date_month }}</code>
                  <!-- <label v-if="label != ''">{{ label }}</label> -->
                  <label style="color: #999">Month</label>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm4 mt-0 py-3>
                <v-text-field
                  v-if="c_user.edit"
                  v-model="artistFormData.birth_date_day"
                  label="Day"
                  mask="##"
                  placeholder="00"
                  type="number"
                ></v-text-field>

                <v-flex v-else mt-4>
                  <code>{{ artistFormData.birth_date_day }}</code>
                  <!-- <label v-if="label != ''">{{ label }}</label> -->
                  <label style="color: #999">Day</label>
                </v-flex>
              </v-flex>
            </v-flex>

            <!-- <v-flex xs6 class="mt-3 py-0 px-3" v-else>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="32"
                :nudge-top="18"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="artistFormData.birth_date"
                  label="Birth Date"
                  prepend-icon="event"
                  readonly
                  clearable
                ></v-text-field>
                <v-date-picker
                  v-model="artistFormData.birth_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex> -->

            <!-- <v-flex
              xs6
              class="mt-3 py-0 px-3"
              v-if="!artistFormData.collective == 1"
            >
              <v-checkbox
                v-model="artistFormData.birth_date_only_year"
                color="black"
                label="Only Year"
              ></v-checkbox>
            </v-flex> -->

            <!-- DEATH DATE -->
            <v-flex xs12 sm6 d-flex>
              <v-flex
                xs6
                class="mt-3 py-0 pl-3"
                v-if="
                  artistFormData.death_date_only_year == 1 ||
                  artistFormData.collective == 1
                "
              >
                <v-text-field
                  v-if="c_user.edit"
                  clearable
                  v-model="artistFormData.death_date_year"
                  mask="####"
                  label="Death Year"
                  prepend-inner-icon="event"
                ></v-text-field>

                <v-flex v-else mt-4>
                  <code>{{ artistFormData.death_date_year }}</code>
                  <!-- <label v-if="label != ''">{{ label }}</label> -->
                  <label style="color: #999">Death Year</label>
                </v-flex>
              </v-flex>

              <v-flex xs6 class="mt-3 py-0 pl-3" v-else>
                <v-menu
                  v-if="
                    !artistFormData.death_date_only_year ||
                    artistFormData.death_date_only_year == 0 ||
                    artistFormData.death_date_only_year == '' ||
                    artistFormData.death_date_only_year == false ||
                    !artistFormData.collective == 1
                  "
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="32"
                  :nudge-top="18"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    :disabled="!c_user.edit"
                    v-if="
                      artistFormData.death_date_only_year ||
                      artistFormData.death_date_only_year == 0 ||
                      artistFormData.death_date_only_year == '' ||
                      artistFormData.death_date_only_year == false ||
                      !artistFormData.collective == 1
                    "
                    slot="activator"
                    v-model="artistFormData.death_date"
                    label="Death Date"
                    prepend-inner-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker
                    :disabled="!c_user.edit"
                    v-model="artistFormData.death_date"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex
                xs6
                class="mt-3 py-0 px-3"
                v-if="!artistFormData.collective == 1"
              >
                <v-checkbox
                  :disabled="!c_user.edit"
                  v-model="artistFormData.death_date_only_year"
                  color="black"
                  label="Only Year"
                ></v-checkbox>
              </v-flex>
            </v-flex>

            <!-- <v-flex xs12 sm6 class="px-3">
              <v-text-field
                v-model="artistFormData.birth_city"
                :label="artistFormData.collective==1 ? 'Formation city' : 'Birth city'"
              ></v-text-field>
            </v-flex> -->

            <v-flex pl-3 pr-2 xs12 sm6>
              <!-- <label>Birth Place</label> -->
              <v-text-field
                v-if="c_user.edit"
                :label="
                  artistFormData.collective == 1
                    ? 'Formation place'
                    : 'Birth place'
                "
                v-model="artistFormData.birthplace"
                hide-details
              ></v-text-field>

              <v-flex v-else>
                <code>{{ artistFormData.birthplace }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">{{
                  artistFormData.collective == 1
                    ? 'Formation place'
                    : 'Birth place'
                }}</label>
              </v-flex>
            </v-flex>

            <v-flex xs12 md6 class="px-3">
              <v-autocomplete
                v-if="c_user.edit"
                :items="this.countries"
                v-model="artistFormData.nationality"
                :item-value="(item) => item.name.common"
                :item-text="(item) => item.name.common"
                label="Nationality"
              ></v-autocomplete>

              <v-flex v-else>
                <code>{{ artistFormData.nationality }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Nationality</label>
              </v-flex>

              <!-- vypocet regionu a subregionu z nationality -->
              <small
                v-if="
                  !artistFormData.nationality &&
                  artistFormData.nationality != 0 &&
                  artistFormData.nationality != '' &&
                  artistFormData.nationality != null
                "
                class="pt-1 grey--text"
              >
                {{
                  this.countries.find(
                    (c) => c.name.common === artistFormData.nationality
                  ).region
                }}
                /
                {{
                  this.countries.find(
                    (c) => c.name.common === artistFormData.nationality
                  ).subregion
                }}
              </small>
              <!-- ak nedokaze zobrazit ulozenu hodnotu, tak ju musí zobraziť pod selectom  -->
              <small
                v-if="
                  !this.countries.find(
                    (c) => c.name.common === artistFormData.nationality
                  )
                "
                class="pt-1 grey--text"
              >
                {{ artistFormData.nationality }}
              </small>
            </v-flex>

            <!-- <v-flex xs12 sm6 px-3>
              <v-autocomplete
                hide-details
                :items="this.countries"
                v-model="artistFormData.birth_country"
                :label="
                  artistFormData.collective == 1
                    ? 'Formation country'
                    : 'Birth country'
                "
                :item-value="item => item.name.common"
                :item-text="item => item.name.common"
              ></v-autocomplete>
              <small v-if="artistFormData.birth_country != 0 && artistFormData.birth_country != '' && artistFormData.birth_country != null" class="pt-1 grey--text">
                {{ this.countries.find(c => c.name.common === artistFormData.birth_country).region }} / 
                {{ this.countries.find(c => c.name.common === artistFormData.birth_country).subregion }}
              </small>

            </v-flex> -->

            <v-flex px-3 xs12 v-if="!artistFormData.collective == 1">
              <!-- <label>Birth Place</label> -->
              <v-text-field
                v-if="c_user.edit"
                label="Death Place"
                v-model="artistFormData.death_place"
                hide-details
              ></v-text-field>

              <v-flex v-else>
                <code>{{ artistFormData.death_place }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Death Place</label>
              </v-flex>
            </v-flex>

            <section-header text="Other"></section-header>

            <!-- <v-flex
              style="background-color: #292929; color: #ddd; line-height: 22px"
              class="px-2 py-0 mt-3 xs12"
            >
              <h3 class="font-weight-bold body-2 xs12 flex">Other</h3>
            </v-flex> -->

            <v-flex px-3 my-3 xs12>
              <v-textarea
                v-if="c_user.edit"
                class="my-0"
                auto-grow
                box
                rows="1"
                hide-details
                v-model="artistFormData.livesandworks"
                label="Lives & Works"
              ></v-textarea>

              <v-flex v-else mt-4>
                <code>{{ artistFormData.livesandworks }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Lives & Works</label>
              </v-flex>
            </v-flex>

            <!-- <v-flex px-3 my-3 xs12 sm6>
              <v-text-field
                label="Lives & works - city"
                v-model="artistFormData.livesandworks_city"
                hide-details
              ></v-text-field>
            </v-flex> -->

            <!-- <v-flex xs12 sm6 px-3 my-3 >
              <v-autocomplete
                hide-details
                :items="this.countries"
                v-model="artistFormData.livesandworks_country"
                label="Lives & works - country"
                :item-value="item => item.name.common"
                :item-text="item => item.name.common"
              ></v-autocomplete>
              <small v-if="artistFormData.livesandworks_country != 0 artistFormData.livesandworks_country != '' && artistFormData.livesandworks_country != null" class="pt-1 grey--text">
                {{ this.countries.find(c => c.name.common === artistFormData.livesandworks_country).region }} / 
                {{ this.countries.find(c => c.name.common === artistFormData.livesandworks_country).subregion }}
              </small>
            </v-flex> -->

            <v-flex px-3 my-3 xs12 v-if="!artistFormData.collective == 1">
              <v-textarea
                v-if="c_user.edit"
                class="my-0"
                auto-grow
                box
                rows="1"
                hide-details
                v-model="artistFormData.bio"
                label="Bio"
              ></v-textarea>

              <v-flex v-else>
                <code>{{ artistFormData.bio }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Bio</label>
              </v-flex>
            </v-flex>

            <v-flex px-3 xs12 my-3>
              <v-textarea
                v-if="c_user.edit"
                class="my-0"
                auto-grow
                rows="1"
                box
                hide-details
                v-model="artistFormData.birth_date_text"
                label="Note"
              ></v-textarea>

              <v-flex v-else>
                <code>{{ artistFormData.birth_date_text }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Note</label>
              </v-flex>
            </v-flex>

            <v-flex
              xs6
              class="mx-3 mt-3 py-2"
              v-if="!artistFormData.collective == 1"
            >
              <!-- <v-radio :label="g.name" :value="g.value" class="ml-3" color="black" v-for="g in constants.GENDERS" :key="g.id"></v-radio> -->
              <v-btn-toggle
                v-if="c_user.edit"
                :disabled="!c_user.edit"
                v-model="artistFormData.gender"
              >
                <v-btn
                  small
                  flat
                  v-for="s in constants.GENDERS"
                  :key="s.name"
                  class="px-2"
                  :value="s.name"
                >
                  <span> {{ s.name }} </span>
                </v-btn>
              </v-btn-toggle>

              <v-flex v-else>
                <code>{{ artistFormData.gender }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color: #999">Gender</label>
              </v-flex>
            </v-flex>

            <section-header
              text="Links"
              v-if="
                c_user.edit ||
                (!c_user.edit && artistFormData.artist_links.length > 0)
              "
            ></section-header>

            <!-- <v-flex
              style="background-color: #292929; color: #ddd; line-height: 22px"
              class="px-2 py-0 mt-3 mb-4 xs12"
            >
              <h3 class="font-weight-bold body-2 xs12 flex">Links</h3>
            </v-flex> -->

            <v-flex
              class="px-3 py-1 mt-0 elevation-0 xs12"
              v-for="al in artistFormData.artist_links"
              :key="al.id"
            >
              <a
                :href="al.url"
                target="_blank"
                style="line-height: 40px"
                class="pb-0"
              >
                <v-icon
                  color="black"
                  style="line-height: 15px"
                  class="pt-1 mr-2"
                  >open_in_new</v-icon
                >
                <b>{{ al.name }}</b> - {{ al.url }}
              </a>
              <v-btn
                v-if="c_user.edit || c_user.delete_rights"
                icon
                @click="deleteLink(al)"
                ><v-icon color="red">delete</v-icon></v-btn
              >
            </v-flex>

            <v-card-title class="" v-if="c_user.edit">
              <v-list-tile class="xs12">
                <v-layout row my-0 py-0 mr-3>
                  <v-flex xs12 md2 mr-2>
                    <h4 class="ml-2 mt-2 pt-2 mr-0 black--text">Add Link</h4>
                  </v-flex>
                  <v-flex xs12 md4 mr-2>
                    <v-text-field
                      color="white"
                      solo
                      dark
                      label="Name"
                      v-model="artistLink.name"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 mr-2>
                    <v-text-field
                      color="white"
                      solo
                      dark
                      label="URL"
                      v-model="artistLink.url"
                      hide-details
                      placeholder='f.e. "tb-cms.org"'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2 mr-2>
                    <v-btn :disabled="!valid2" small @click="saveLink">
                      save link
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </v-card-title>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>

    <v-card
      flat
      class="px-3 pt-4 mt-4 elevation-0"
      v-if="currentTab == 'public'"
    >
      <visibility-settings :artist="artistFormData"></visibility-settings>
    </v-card>

    <!-- <v-card class="px-3 pt-4 mt-4 elevation-0" v-if="currentTab=='basic'">
      <v-container grid-list-md fluid>
        <v-layout row wrap>

          <v-flex style="background-color:#292929; color: #ddd; line-height:22px;" class="px-2 mb-3 xs12">
            <h3 class="font-weight-bold body-2 xs12 flex"> Links</h3>
          </v-flex>
          
          <v-flex class="px-3 py-1 mt-0 elevation-0 xs12" v-for="al in artistFormData.artist_links" :key="al.id">
            <a :href="al.url" target="_blank" style="line-height: 40px;" class="pb-0">
              <v-icon color="black" style="line-height: 15px;" class="pt-1 mr-2">open_in_new</v-icon>
              <b>{{al.name}}</b> - {{al.url}}
            </a>
            <v-btn icon @click="deleteLink(al)"><v-icon color="red">delete</v-icon></v-btn>
          </v-flex>
        </v-layout>

      <v-card-title class="black">
        <v-list-tile class="xs12">
          <v-layout row my-0 py-0 mr-3>
            <v-flex xs12 md2 mr-2>
              <h4 class="ml-2 mt-2 pt-2 mr-4 white--text">Add Link</h4>
            </v-flex>
            <v-flex xs12 md4 mr-2>
              <v-text-field color="white" solo dark label="Name" v-model="artistLink.name" hide-details ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 mr-2>
              <v-text-field color="white" solo dark label="URL" v-model="artistLink.url" hide-details placeholder='f.e. "tb-cms.org"'></v-text-field>
            </v-flex>
            <v-flex xs12 md2 mr-2>
              <v-btn :disabled="!valid2" @click="saveLink"> save link </v-btn>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </v-card-title> -->

    <!-- <v-layout row wrap mt-3>
          <v-form @submit.prevent ref="form2" v-model="valid2" lazy-validation v-if="currentTab=='basic'">
            <h3 class="ml-3 mt-3">Add Link</h3>
            <v-flex px-3 xs12>
              <label>Name</label>
              <v-text-field label="Name" v-model="artistLink.name" hide-details ></v-text-field>
            </v-flex>
            <v-flex px-3 xs12>
              <label>Name</label>
              <v-text-field label="URL" v-model="artistLink.url" hide-details ></v-text-field>
            </v-flex>
            <v-flex px-3 xs12>
              <v-btn :disabled="!valid2" @click="saveLink"> submit </v-btn>
              <v-btn @click="clear">cancel</v-btn>
            </v-flex>
          </v-form>
        </v-layout> -->

    <!-- </v-container>
    </v-card> -->

    <v-card
      flat
      class="px-3 pt-4 mt-4 elevation-0"
      v-if="currentTab == 'artworks'"
    >
      <v-container grid-list-md fluid>
        <v-layout row wrap class="xs12">
          <v-flex
            style="background-color: #292929; color: #ddd; line-height: 22px"
            class="px-2 py-0 xs12"
          >
            <h3 class="font-weight-bold body-2 xs12 flex">Artist Artworks</h3>
          </v-flex>
          <view-artworks :artist="artistFormData" class="xs12"></view-artworks>
        </v-layout>
      </v-container>
    </v-card>

    <v-card
      flat
      class="px-3 pt-4 mt-4 elevation-0"
      v-if="currentTab == 'multi_artist'"
    >
      <v-container grid-list-md fluid class="xs12">
        <v-layout row wrap class="xs12">
          <v-flex
            style="background-color: #292929; color: #ddd; line-height: 22px"
            class="px-2 py-0 xs12"
          >
            <h3 class="font-weight-bold body-2 xs12 flex">Multi-Artist</h3>
          </v-flex>
          <multi-artist :artist="artistFormData" class="xs12"></multi-artist>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import EditField from './EditField'
import ViewArtworks from './ViewArtworks'
import EditFieldHeader from './EditFieldHeader'
import * as qs from 'querystring'
import MultiArtist from '@/components/artists/MultiArtist.vue'
import countries from '@/data/countries'
import constants from '@/data/constants'
import SectionHeader from '../layout/SectionHeader.vue'
import VisibilitySettings from '@/components/public/VisibilitySettings'

export default {
  data() {
    return {
      constants: constants,
      name_exists: false,
      snackbar: false,
      sText: 'Working ...',
      sColor: 'black',
      timeout: 5000,
      artistLink: {},
      countries: countries.countries,
      menu2: false,
      menu: false,
      drawer: false,
      artistFormData: Object.assign({}, this.artist),
      valid: true,
      valid2: true,
      currentTab: this.$store.state.currentTabArtist
        ? this.$store.state.currentTabArtist
        : 'basic',
    }
  },
  props: ['artist', 'field'],
  // beforeRouteEnter () {
  //   this.result = Object.assign({},this.$store.state.artists.find(a => a.is==this.$route.params.id))
  // },
  beforeMount() {
    // console.log('beforemount')
    // console.log(this.artistFormData.nationality)
    this.artistFormData = Object.assign({}, this.artist)
    if (this.$route.params.artist) {
      this.result = this.$route.params.artist
    } else {
      this.result = this.$store.state.artists.find(
        (a) => a.id == this.$route.params.id
      )
      this.artistFormData = this.result
    }
    this.getArtist()
    // console.log('beforemount after')
    // console.log(this.artistFormData.nationality)
  },
  methods: {
    check_name(value) {
      if (value) {
        var a = Object.assign([], this.$store.state.artists)
        var b = a.filter((aa) => aa.name === value)
        this.name_exists = b.length > 0
      }
    },
    setCurrentTab(tab) {
      this.currentFields = this.constants.ARTIST.tabs.fields
      // if (!this.currentFields) {
      //   this.currentFields = this.constants.ARTIST.tabs[tab].fields
      // }
      this.saveCurrentTab(tab)
      this.currentTab = tab
    },
    saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTabArtist', tab)
    },
    saveArtist() {
      this.sColor = 'black'
      this.snackbar = true
      this.sText = 'Saving Artist...'
      // if (this.$refs.form.validate()) {
      // console.log(this.artistFormData)
      // let url = `http://www.tb-cms.org/artists/api_update/${this.artistFormData.id}.json`
      let url = `${this.$globals.apiserver}/artists/${this.artistFormData.id}.json`
      // console.log(url)
      axios
        .put(url, this.artistFormData)
        .then((response) => {
          // this.loading = false;
          // console.log(response.data)
          this.result = response.data
          // this.artistFormData = response.data
          this.$store.dispatch('saveArtist', response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
          this.snackbar = false
          this.snackbar = true
          this.sColor = 'green'
          this.sText = 'Artist Saved.'
          // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
        })
        .catch((error) => {
          // console.log(error)
          this.sColor = 'red'
          this.sText = 'Problem Saving Artist. Try again or contact developer.'
        })
      // }
    },
    saveLink() {
      // if (this.$refs.form.validate()) {
      // console.log(this.artistLink)
      var prefix = 'http://'
      if (this.artistLink.url.substr(0, prefix.length) !== prefix) {
        this.artistLink.url = prefix + this.artistLink.url
      }
      let url = `${this.$globals.apiserver}/artist_links.json`
      this.artistLink.artist_id = this.artistFormData.id
      // console.log(this.artistLink)

      axios
        .post(url, {
          artist_link: this.artistLink,
        })
        .then((response) => {
          // this.loading = false;
          // console.log(response.data)
          this.artistFormData.artist_links.push(response.data)
          this.result = response.data
          this.artistLink = {}
          // this.artistFormData = response.data
          // this.$store.dispatch('addArtist',response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
          // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
        })
        .catch((error) => {
          // console.log(error)
        })
      // }
    },
    deleteLink(l) {
      let url = `${this.$globals.apiserver}/artist_links/${l.id}.json`
      axios
        .delete(url, l.id)
        .then((response) => {})
        .catch((error) => {
          // console.log(error)
        })
      let li = this.artistFormData.artist_links.indexOf(l)
      this.artistFormData.artist_links.splice(li)
      this.$store.dispatch('deleteArtistLink', l)
    },
    submit() {
      // if (this.$refs.form.validate()) {
      // Native form submission is not yet supported
      // console.log(this.artist)
      // var a = {
      //   artist: JSON.stringify(this.artist)
      // }
      //   var params = new URLSearchParams(a)

      // const params = {
      //   firstName: 'Fred',
      //   lastName: 'Flintstone'
      // }
      // console.log(this.artist)
      const art = this.artistFormData
      // console.log(art)

      const requestConfig = {
        url: `${this.$globals.apiserver}/artists/api_update/${this.$route.params.id}`,
        method: 'POST',
        // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
        data: qs.stringify(art),
      }
      const response = axios.request(requestConfig)
      console.log(
        requestConfig.method,
        requestConfig.url,
        response.status,
        response.statusText,
        typeof response.data
      )
      // console.log(response.request._header);

      // const paramsd = new URLSearchParams();
      // paramsd.append('param1', 'value1');
      // paramsd.append('param2', 'value2');

      // axios({
      //   method: 'post',
      //   url: `http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
      //   data: {
      //     firstName: 'Fred',
      //     lastName: 'Flintstone'
      //   }
      // })

      // axios.post(`http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
      //   {params: paramsd},
      //   { headers: {
      //     'Content-type': 'application/x-www-form-urlencoded',
      //     }
      //   }).then(function (response) {
      //     // console.log(response);
      //   })
      //   .catch(function (error) {
      //     // console.log(error);
      //   })
      // axios.post(`http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`, {
      //     // artist: this.artist,
      //     aaaaaaaaa: 'aaaaaaaa'
      //     // name: this.artist.first_name
      //   })
      //   .then(function (response) {
      //     // console.log(response);
      //   })
      //   .catch(function (error) {
      //     // console.log(error);
      //   })
      // }
    },
    clear() {
      this.$refs.form.reset()
    },
    updateForm(fieldName, value) {
      this.$set(this.artistFormData, fieldName, value)
      // this.$emit("input", this.artist);
    },
    getArtist() {
      let url = `${this.$globals.apiserver}/artists/${this.$route.params.id}.json`
      axios
        .get(url)
        .then((response) => {
          this.result = response.data
          // console.log(response.data)
          this.artistFormData = response.data
          // console.log('getartist')
          // console.log(this.artistFormData.nationality)
          // this.artist = response.data.artist
        })
        .catch((error) => {
          // console.log(error)
        })
      // console.log(this.artistFormData)
    },
  },
  computed: {
    options_c: {
      get() {
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      },
    },
    processedArtist() {
      let processedArtist = this.result
      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtist)
      return processedArtist
    },
    // value_calculated (field) {
    //   if (field.table == "artists") {
    //     return eval('this.artwork.artist.'+ field.name)
    //   } else {
    //     return eval('this.artwork.'+ field.name)
    //   }
    // }
    // full_user_fields () {
    //   return this.$store.state.full_user_fields
    // }
  },
  components: {
    EditField,
    ViewArtworks,
    EditFieldHeader,
    MultiArtist,
    SectionHeader,
    VisibilitySettings,
  },
}
</script>

<style scoped>
code {
  border: 0px;
  color: black;
  box-shadow: none;
  font-family: Arial !important;
  font-weight: 100;
  background: none !important;
  font-size: 16px;
  line-height: 17px;
  margin-top: 0px;
  padding-left: 0px;
}
code::before {
  content: '';
}
label {
  color: rgb(128, 128, 128) !important;
  border-top: 1px solid black;
  margin-top: 0px !important;
  display: block;
}
/* h1 { font-size: 1em !important; margin-left: 10px; } */
/* small {font-size:1em; float:left; display: block;} */
/* .toolbar__title {
      margin-left: 20px!important;
      font-weight: 200;
  } */
/* .v-tabs-bar {top: 200px;position: fixed;z-index: 1;}  */
/* .toolbar {margin-top: 0px;top: 80px;position: fixed;z-index: 1;} */
/* div.tabs__bar.theme--dark.grey {margin-top: 0px;top: 200px;position: fixed;z-index: 1;} */
/* .tabs__items {margin-top: 120px;} */
</style>



// WEBPACK FOOTER //
// src/components/artists/EditArtist.vue